import React from 'react'
import {withStyles} from '@material-ui/core/styles'
import {ThemeProvider} from '@material-ui/core/styles'
import {theme} from 'theme'
import MenuView from 'components/Menu/MenuView'
import {useParams, Redirect} from 'react-router-dom'

const styles = theme => ({

})

const MenuLanguageSwitch = withStyles(styles)(({classes, ...props}) => {
  const {lang} = useParams()
  return <>
    <ThemeProvider theme={theme}>
        <MenuView lang={lang}/>
        {lang !== 'el' && lang !== 'en' ? <Redirect to={'/'}/> : null}
    </ThemeProvider>
  </>
})

export default MenuLanguageSwitch